import { render, staticRenderFns } from "./CompanyLayout.vue?vue&type=template&id=1331c3a2&"
import script from "./CompanyLayout.vue?vue&type=script&lang=js&"
export * from "./CompanyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports